import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import * as punctualAdjustApproversActions from 'action/punctualAdjustApprovers'
import { isEmpty } from 'utils/validations'
import ContentHeader from 'component/utils/ContentHeader'
import ApproversEditForm from 'component/punctualAdjustApprovers/EditForm'
import PunctualAdjustApproversTable from 'component/punctualAdjustApprovers/Table'
import Notification from 'component/utils/Notification'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Pagination from 'component/pagination/Pagination'
import { ToastContainer } from 'react-toastify'
import { renderToastSuccessMsg, renderToastWarn } from 'utils/ToastUtils'
// import Modal from 'component/Modal/GenericModal'

class PunctualAdjustApproversContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    error: PropTypes.object,
    updated: PropTypes.bool,
    removed: PropTypes.bool,
    menuMissions: PropTypes.array.isRequired,
    update: PropTypes.func.isRequired,
    fetchManagerBranchMissions: PropTypes.func.isRequired,
    getMenuMission: PropTypes.func.isRequired,
    resetEditMenuMissions: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired,
    pages: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    success: PropTypes.string.isRequired,
    clearSuccessMessage: PropTypes.func.isRequired,
    fetchMissionsOptions: PropTypes.func,
    options: PropTypes.array,
  }

  constructor(props) {
    super(props)

    this.state = {
      formVisible: true,
      tableVisible: true,
      renderButtons: false,
      updateOptions: false,
    }
  }

  componentDidMount() {
    const {
      fetchManagerBranchMissions,
      fetchMissionsOptions,
      auth: { user },
    } = this.props

    fetchMissionsOptions(user.dsToken)
    fetchManagerBranchMissions(user.dsToken)
  }

  componentWillUnmount() {
    const { resetEditMenuMissions } = this.props

    resetEditMenuMissions()
  }

  componentWillReceiveProps() {
    const { formVisible } = this.state
    const { updated } = this.props

    /* istanbul ignore else */
    if (formVisible && updated) {
      this.invertStates()
    }
  }

  componentDidUpdate(prevProps) {
    const { clearSuccessMessage, error, success, translate } = this.props

    if (success !== prevProps.success && success) {
      renderToastSuccessMsg(translate(success))

      clearSuccessMessage()
    }

    if (error !== prevProps.error && error) {
      renderToastWarn(error)
    }
  }

  setRenderButtons = (value) => {
    this.setState({ renderButtons: value })
  }

  invertStates = () => {
    if (window.innerWidth > 768) {
      this.setState({ formVisible: true })
      this.setState({ tableVisible: true })
      return
    }

    let { formVisible, tableVisible } = this.state

    formVisible = !formVisible
    tableVisible = !tableVisible

    this.setState({ formVisible })
    this.setState({ tableVisible })

    /* istanbul ignore else */
    if (formVisible) {
      const { resetEditMenuMissions } = this.props
      resetEditMenuMissions()
    }
  }

  handleFetchManagerBranchMissions = (page) => {
    const {
      fetchManagerBranchMissions,
      auth: { user },
    } = this.props

    fetchManagerBranchMissions(user.dsToken, page)
  }

  handleSubmit = (params, onSuccess) => {
    const {
      update,
      auth: { user },
    } = this.props

    update(user.dsToken, { dsMissionList: params }, onSuccess)
  }

  getMenuMission = (index) => {
    const { getMenuMission } = this.props

    getMenuMission(index)
  }

  delMenuMission = async (values, onSuccess) => {
    const {
      remove,
      auth: { user },
    } = this.props

    remove(user.dsToken, values, onSuccess).then(() =>
      this.setState({
        updateOptions: true,
      })
    )
  }

  renderNotification = () => {
    const { translate } = this.props
    return (
      <Notification
        className='notification-warning notification-warning-mission margin-top'
        message={translate('punctual-adjust-approvers.missions-not-found')}
      />
    )
  }

  renderFieldsErrors = (fields) => (
    <li className='margin-left' key={fields.naField}>
      {fields.naField ? `${fields.naField}:` : ''} {fields.dsDetail}
    </li>
  )

  get options() {
    const { options } = this.props

    return (options || []).map((option) => ({
      value: option.cdMission,
      label: option.dsMission,
    }))
  }

  render() {
    const { translate, error, menuMissions, pages, count, current, auth } =
      this.props

    const { tableVisible, renderButtons } = this.state

    const initialValues = {}

    return (
      <section className='menu-mission new-style'>
        <ContentHeader>
          {translate('punctual-adjust-approvers.title')}
        </ContentHeader>

        {/* <Modal /> */}

        <section>
          <div className='container-fluid'>
            {
              // shows notification after an update
              error && error.fields ? (
                <div className='margin-top margin-botton notification notification-warning'>
                  {error.fields.map(this.renderFieldsErrors)}
                </div>
              ) : error ? (
                <div className='margin-top margin-botton notification notification-warning'>
                  {error.message.dsMessage}
                </div>
              ) : (
                ''
              )
            }
          </div>

          <ApproversEditForm
            translate={translate}
            onSubmit={this.handleSubmit}
            initialValues={initialValues}
            error={error}
            auth={auth}
            invertStates={this.invertStates}
            options={this.options}
          />

          <Row className='container-mobile container-flex'>
            {tableVisible && (
              <Col xs={12} sm={12} md={12} className='show-first-on-mobile'>
                {/* <legend className='ApproversTable'>
                  {translate('punctual-adjust-approvers.added-mission-list')}
                </legend> */}

                {
                  <PunctualAdjustApproversTable
                    translate={translate}
                    menuMissions={menuMissions}
                    delMenuMission={this.delMenuMission}
                    renderButtons={renderButtons}
                    setRenderButtons={this.setRenderButtons}
                    onSubmit={this.handleSubmit}
                    user={auth.user}
                  />
                }
              </Col>
            )}
            {pages > 1 && tableVisible && (
              <Col className='show-second-on-mobile align-center margin-top-double margin-bottom-double'>
                <div className='align-center margin-top'>
                  <Pagination
                    getPage={this.handleFetchManagerBranchMissions}
                    pages={pages}
                    current={current}
                    count={count}
                  />
                </div>
              </Col>
            )}

            {tableVisible && !renderButtons && (
              <Col
                xs={12}
                md={12}
                className='hidden-button show-third-on-mobile margin-bottom'
              >
                <button
                  role='button'
                  type='button'
                  onClick={this.invertStates}
                  display='none'
                  className='button button-primary button-full'
                >
                  {translate('mission.add-new-mission')}
                </button>
              </Col>
            )}
          </Row>
          {isEmpty(menuMissions) && (
            <div className='no-items-present'>
              <h2>Sem cadastros</h2>
            </div>
          )}
        </section>
        <ToastContainer newestOnTop />
      </section>
    )
  }
}

/*
 * Maps redux state to component props
 */
/* istanbul ignore next */
const mapStateToProps = ({
  punctualAdjustApproversReducer,
  paginateReducer,
}) => ({
  menuMissions: punctualAdjustApproversReducer.list.records,
  options: punctualAdjustApproversReducer.list.options,
  updated: punctualAdjustApproversReducer.edit.updated,
  removed: punctualAdjustApproversReducer.edit.removed,
  error: punctualAdjustApproversReducer.edit.error,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
  success: punctualAdjustApproversReducer.success,
})

/*
 * Maps actions and dispatch them to component props
 */
/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(punctualAdjustApproversActions, dispatch)

/*
 * Connects component to I18next
 */
const PunctualAdjustApproversTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(PunctualAdjustApproversContainer)

/*
 * Exports component connected to redux as default
 */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PunctualAdjustApproversTranslated)

/*
 * Exports as component
 */
export { PunctualAdjustApproversContainer as PunctualAdjustApprovers }
